import { render } from "./AddProduitRestreintPage.vue?vue&type=template&id=fbec205a&ts=true"
import script from "./AddProduitRestreintPage.vue?vue&type=script&lang=ts"
export * from "./AddProduitRestreintPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__